export { default as StringFilterBadge } from './StringFilterBadge';
